import script from "./alertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./alertModal.vue?vue&type=script&setup=true&lang=js"

import "./alertModal.vue?vue&type=style&index=0&id=4317fbe4&lang=scss&scoped=true"

import exportComponent from "D:\\works\\淘游虎\\yududs-im\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4317fbe4"]])

export default __exports__